document.addEventListener( "DOMContentLoaded", () => {
	const mobileNavigationMenuSelector = ".mobile-navigation-menu"
	const menu = new Mmenu( mobileNavigationMenuSelector, {
		extensions: [
			"position-back",
			"position-top",
		],
		navbar: false,
		screenReader: {
			aria: true,
			text: true,
		},
		slidingSubmenus: false
	}, {
		classNames: {
			selected: "active"
		},
		offCanvas: {
			page: {
				selector: "#page"
			}
		}
	});

	$( ".mobile-menu-button" ).click( () => {
		if ( $( mobileNavigationMenuSelector ).hasClass( "mm-menu_opened" ) ) {
			menu.API.close()
		}
		else {
			menu.API.open()
		}
	});

	/* Sticky Header */
	addStickyHeader();
	$(window).scroll(function() {
		addStickyHeader();
	});

	$('.menu').on('click', function() {
		$('body').addClass('no-scroll');
	});
	$('.close').on('click', function() {
		$('body').removeClass('no-scroll');
	});


	/* Homepage */
	const footerElement = document.querySelector('.footer-container.is-homepage');
	const footerElementBottom = document.querySelector('.footer-signoff-section-2.is-homepage');

	document.querySelectorAll('.team_member-wrap').forEach(element => {
		element.addEventListener('mouseenter', () => {
			footerElement.classList.add('hovered');
			footerElementBottom.classList.add('hovered');
		});

		element.addEventListener('mouseleave', () => {
			footerElement.classList.remove('hovered');
			footerElementBottom.classList.remove('hovered');
		});
	});
});

function addStickyHeader() {
	if ($(window).scrollTop() > 1) {
		$('.section-nav').addClass('sticky');
	}
	else {
		$('.section-nav').removeClass('sticky');
	}
}
